import { Avatar, Box, Stack, Typography } from '@mui/material';
import type { Theme } from '@mui/material/styles';

function UserInfo() {
  return (
    <Box sx={StyleSheet.container}>
      <Avatar sx={StyleSheet.userPicture} />

      <Stack sx={StyleSheet.userInfoWrapper} direction="column">
        <Typography>Jhon Smith</Typography>
        <Typography className="jobTitle">Delivery Director</Typography>
      </Stack>
    </Box>
  );
}

const StyleSheet = {
  container: (theme: Theme) => ({
    display: 'flex',
    alignItems: 'center',
    margin: '20px 24px 0px 24px',
    marginLeft: '24px',
    background: (theme.palette.grey as unknown as Record<string, string>)[60],
    borderRadius: '2px',
    padding: '8px',
    '& .MuiTypography-root': {
      fontFamily: 'Inter',
      color: theme.palette.common.white,
      fontWeight: 500,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '&.jobTitle': {
        fontSize: '12px',
        color: (theme.palette.grey as unknown as Record<string, string>)[40],
      },
    },
  }),
  userInfoWrapper: {
    width: '113px',
  },
  userPicture: {
    marginRight: '10px',
  },
};

export default UserInfo;
